import { render, staticRenderFns } from "./CustomizablePictureAlert.vue?vue&type=template&id=28b63b28&scoped=true&"
import script from "./CustomizablePictureAlert.vue?vue&type=script&lang=js&"
export * from "./CustomizablePictureAlert.vue?vue&type=script&lang=js&"
import style0 from "./CustomizablePictureAlert.vue?vue&type=style&index=0&id=28b63b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b63b28",
  null
  
)

export default component.exports